import script from "./ClientProjectHisData.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientProjectHisData.vue?vue&type=script&setup=true&lang=js"

import "./ClientProjectHisData.vue?vue&type=style&index=0&id=564fc0b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564fc0b8"]])

export default __exports__